export const BASE_DOMAIN = 'technoscaffold.com';
export const IS_LOCAL = window.location.hostname === 'localhost';
export const LOCAL_API_URL =
  process.env.REACT_APP_LOCAL_API_URL || "http://localhost:8000";
  // process.env.REACT_APP_LOCAL_API_URL || "https://api.shivansh.technoscaffold.com";
export const LOCAL_TENANT = process.env.REACT_APP_LOCAL_TENANT || 'local-tenant';

export const getTenantApiUrl = (tenantSlug) => {
  if (IS_LOCAL) {
    return LOCAL_API_URL;
  }
  return `https://api.${tenantSlug}.${BASE_DOMAIN}`;
};

export const getCurrentTenantSlug = () => {
  const hostname = window.location.hostname;
  if (IS_LOCAL) {
    return LOCAL_TENANT;
  }
  const matches = hostname.match(/^(?:api\.)?([^.]+)\.technoscaffold\.com$/);
  return matches ? matches[1] : null;
}; 